function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("mask", {
  id: "trezor_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 0,
  width: 12,
  height: 16
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.667.667h10.666V16H2.667V.667z",
  fill: "#fff"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#trezor_svg__a)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.52 12.516l-3.187 1.47-3.187-1.47v-4.89h6.374v4.89zM6.496 4.565c0-.91.825-1.65 1.838-1.65 1.012 0 1.837.74 1.837 1.65V5.71H6.496V4.565zm5.61 1.145V4.565C12.107 2.599 10.414 1 8.335 1c-2.08 0-3.773 1.599-3.773 3.565V5.71H3v8.164h.01l5.324 2.46 5.322-2.46h.01V5.71h-1.56z",
  fill: "#1722A2"
}));

function SvgTrezor(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIyIiB5PSIwIiB3aWR0aD0iMTIiIGhlaWdodD0iMTYiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIuNjY2NzUgMC42NjY3NDhIMTMuMzMzNFYxNi4wMDAxSDIuNjY2NzVWMC42NjY3NDhaIiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41MjAxIDEyLjUxNjFMOC4zMzM0NyAxMy45ODUxTDUuMTQ2NCAxMi41MTYxVjcuNjI2MDZIMTEuNTIwMVYxMi41MTYxWk02LjQ5NjM0IDQuNTY0NTdDNi40OTYzNCAzLjY1NDc5IDcuMzIwNTggMi45MTQ5NiA4LjMzNDMzIDIuOTE0OTZDOS4zNDYzNSAyLjkxNDk2IDEwLjE3MSAzLjY1NDc5IDEwLjE3MSA0LjU2NDU3VjUuNzEwMzJINi40OTYzNFY0LjU2NDU3Wk0xMi4xMDY1IDUuNzEwMzNWNC41NjQ1OEMxMi4xMDY1IDIuNTk4OTMgMTAuNDEzNCAxIDguMzM0NDEgMUM2LjI1NDEzIDEgNC41NjEwOCAyLjU5ODkzIDQuNTYxMDggNC41NjQ1OFY1LjcxMDMzSDNWMTMuODczNkgzLjAxMDgyTDguMzMzNTUgMTYuMzMzNEwxMy42NTYzIDEzLjg3MzZIMTMuNjY2N1Y1LjcxMDMzSDEyLjEwNjVaIiBmaWxsPSIjMTcyMkEyIi8+CjwvZz4KPC9zdmc+Cg==";
export { SvgTrezor as ReactComponent };